import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Pipe({
  name: 'urlPerEnvironment',
  standalone: true
})
export class UrlPerEnvPipe implements PipeTransform {
  transform(claimName: string): string {
    return environment.menuExternalLinks[claimName.toLowerCase()];
  }
}
